import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Select,
  Typography,
  Table,
  Modal,
  Flex,
} from "antd";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { Layout } from "antd";
import "../styles/App.css";
import CustomTableLoader from "src/components/common/CustomTableLoader";

const VehicleAccount: React.FC = (record: any) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const { Title } = Typography;
  const [toPayForm] = Form.useForm();
  const [paidForm] = Form.useForm();
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [selectedCabId, setSelectedCabId] = useState<string | null>(null);
  const [selectedBonupoint, setSelectedBonupoint] = useState<string | null>(
    null
  );
  const [selectedCab, setSelectedCab] = useState<any>(null);
  const [status, setStatus] = useState<any>(null);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const [isPaidModalVisible, setPaidModalVisible] = useState(false);
  const [searchText, setSearchText] = useState<string>("");
  const [activeFilter, setActiveFilter] = useState<any[]>([]);
  const [limit, setLimit] = useState<number>(10);
  const [skip, setSkip] = useState<number>(0);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const branchid = userData.cityid;
  const vehicleAccountData = useSelector(
    (state: any) => state.vehicleAccount.data || {}
  );
  const loading = useSelector(
    (state: RootState) => state.vehicleAccount.loading
  );
  const update = useSelector((state: RootState) => state.vehicleAccount.create);
  const [selectedRowKey, setSelectedRowKey] = useState<React.Key | null>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [month, setMonth] = useState<any>(null);

  // const filteredDataSource = cabList.filter((record: any) => {
  //   const cabId = (record.cab_id || "").toLowerCase();
  //   const search = searchText.toLowerCase();

  //   const matchesCabId = cabId.includes(search);
  //   const matchesStatus = record.isactive?.toLowerCase().includes(search);

  //   return matchesCabId || matchesStatus;
  // });

  // const finalFilteredData = filteredDataSource.filter((row: any) => {
  //   if (activeFilter.length > 0) {
  //     return activeFilter.includes(row.isactive);
  //   }
  //   return true;
  // });

  const rowSelection = {
    type: "radio" as const,
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKey(selectedRowKeys[0] || null);
      setSelectedRows(selectedRows);
    },
  };

  const columns: any = [
    {
      title: "Cab ID",
      dataIndex: "CabId",
      key: "CabId",
      align: "center",
    },
    {
      title: "Last Login Date",
      dataIndex: "Date",
      key: "Date",
      align: "center",
      render: (text: any) => text.split(",")[0],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
    },
    {
      title: "Balace",
      dataIndex: "balace",
      key: "balace",
      align: "center",
      // width: 0,
    },
    {
      title: "Exit Date",
      dataIndex: "exitdate",
      key: "exitdate",
      align: "center",
      // width: 0,
    },
  ];

  const handleFetch = () => {
    // dispatch(fetchdata(cabId, month));
  };
  return (
    <Layout
      style={{ backgroundColor: "whitesmoke", height: "calc(100vh - 100px)" }}
    >
      <Flex style={{ flexDirection: "column", rowGap: "20px" }}>
        <Flex style={{ width: "100%" }}>
          <Flex style={{ width: "50%", justifyContent: "start" }}>
            <Title
              level={3}
              style={{
                fontSize: "35px",
                fontWeight: "bolder",
                color: "black",
                fontFamily: "serif",
                textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
                margin: 0,
              }}
            >
              Exide vehicles
            </Title>
          </Flex>
          <Flex style={{ width: "50%", justifyContent: "end" }}>
            <Typography.Text
              strong
              style={{
                width: "30%",
                fontSize: "20px",
                padding: "7px",
                backgroundColor: "transparent",
                borderRadius: "12px",
                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                // transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
            >
              Cabs :
            </Typography.Text>
          </Flex>
        </Flex>
        <Flex
          style={{ flexDirection: "row", width: "100%", justifyContent: "end" }}
        >
          <Flex style={{ width: "70%", gap: "2%" }}>
            <DatePicker
              picker="month"
              className="date-input"
              onChange={(date, dateString) => {
                setMonth(dateString as string);
              }}
            />
            <Button
              type="primary"
              size="middle"
              style={{ padding: "0 24px", backgroundColor: "#884299" }}
              onClick={handleFetch}
            >
              GO
            </Button>
             <Button
              style={{ color: "white", background: "#0050b3" }}
              // onClick={handleOpenModal}
              disabled={!selectedRows.length}
            >
              Revert
            </Button>
          </Flex>
          <Flex style={{ width: "30%", justifyContent: "end", gap: "2%" }}>
            <CSVLink
              data={vehicleAccountData}
              headers={[
                { label: "Cab ID", key: "CabId" },
                { label: "Last Login Date", key: "Date" },
                { label: "Status", key: "status" },
                { label: "Balace", key: "balace" },
              ]}
              filename="vehicle_accounts.csv"
            >
              <Button
                icon={<DownloadOutlined />}
                style={{
                  background: "linear-gradient(45deg, #159957, #155799)",
                  color: "white",
                }}
              >
                Download
              </Button>
            </CSVLink>
            <Input
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined />}
              style={{ width: "50%", height: "30px" }}
            />
          </Flex>
        </Flex>
        <Table
          rowSelection={rowSelection}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          columns={columns}
          rowKey={(record: any) => record.cab_id || record.cabId}
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          scroll={{ x: "calc(700px + 40%)", y: 50 * 15 }}
          bordered
        />
      </Flex>
    </Layout>
  );
};
export default VehicleAccount;
